import { Bar } from '@elfsight/widget-modal/src';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { isInlineLayout } from '../../utils';
import { LayoutInner } from './layout-inner';

export function Layout() {
  const { layout } = useSettings();

  if (isInlineLayout(layout)) {
    return <LayoutInner />;
  }

  return (
    <Bar
      className={createReadableClass({ component: 'layout', element: 'bar' })}
      mode={layout}
      shadow
    >
      <LayoutInner />
    </Bar>
  );
}
